




























































































































































































































































import {
    Company,
    DateTime, GuiUserlisting,
    IdCard,
    PhoneNumber,
    RegReportResult,
    SiteInOutReportLine,
    TerminalLocationWithStats
} from "../../modules/models";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import DatePicker from "../DatePicker.vue";
import PersonMarker from "../PersonMarker.vue";
import Api from "./Api";
import {arrEquality, Debouncer, numOrNull, queryParams} from "../../modules/utils";
import CardIcon from "../CardIcon.vue";
import {
    ErrorColor,
    UnimportantColor,
    WarningColor,
    DefaultColor,
    MaxRegReportFilterListParams
} from "../../modules/constants";
import CompanyUserRequired from "@/components/CompanyRequired";
import Routes from "@/modules/Routes";
import RegistrationsPageRouteParams, {DateMode} from "@/components/registrations/RegistrationsPageRouteParams";
import ReportPagination from "@/components/registrations/ReportPagination.vue";
import delay from "@/modules/delay";

const left = "left";

interface Header {
    text: string;
    value: string;
    align: string;
    sortable?: boolean;
}

interface Pagination {
    sortBy: string;
    descending: boolean;
    totalItems: number;
}

@Component({
    components: {
        "at-date-picker": DatePicker,
        "at-person-marker": PersonMarker,
        "at-cardicon": CardIcon,
        "at-report-pagination": ReportPagination,
    }
})
export default class RegistrationReport extends CompanyUserRequired {
    @Prop()
    routeParams!: RegistrationsPageRouteParams;

    readonly rowsPerPage = RegReportResult.rowsPerPage;

    loading = false;

    @Inject()
    api!: Api;

    readonly maxCheckedFilterCount = MaxRegReportFilterListParams;

    get dateMode() {
        return this.routeParams.dateMode.valueOf();
    }
    set dateMode(v: number) {
        const rp = this.routeParams.clone();
        rp.dateMode = v;
        if(v === DateMode.all) {
            rp.from = null;
            rp.to = null;
        }
        this.updateRouteParams(rp);
    }

    search = "";

    unimportantColor = UnimportantColor+"8a";
    defaultCardColor = DefaultColor;

    pagination = {
        sortBy: "timeIn",
        descending: true,
        totalItems: 0,
        page: 1,
        rowsPerPage: RegReportResult.rowsPerPage,
    };

    @Watch("pagination", {deep: true})
    onPaginationChanged(newP: Pagination, oldP: Pagination) {
        if(newP.sortBy !== oldP.sortBy || newP.descending !== oldP.descending) {
            const i = this.resultHeaders.findIndex(r => r.value == newP.sortBy);
            if(i > -1) { // sortBy string found
                const o = i + 1; // headers is zero based array
                const posNeg = newP.descending ? -1 : 1;
                this.ordering = posNeg*o; // ordering is negative if sort is descending, positive otherwise
            }
            // Will not do anything if sortBy string is not found.
        }
    }

    @Watch("routeParams", {immediate: true})
    routeParamsChanged(newParams: RegistrationsPageRouteParams, oldParams?: RegistrationsPageRouteParams) {
        if((!oldParams) || !newParams.equal(oldParams)) {
            if(newParams.ordering != 0) {
                const h = this.resultHeaders[Math.abs(this.ordering) - 1];
                this.pagination.sortBy = h.value;
                this.pagination.descending = this.ordering < 0;
            } else {
                this.pagination.sortBy = "";
            }

            if(oldParams && arrEquality(newParams.filterOrgnums, oldParams.filterOrgnums)) {
                // When these are equal some other param changed, so invalidate companies list
                this.companiesDirty = true;
            }
            if(oldParams && arrEquality(newParams.filterUserGuids, oldParams.filterUserGuids)) {
                // user guids not changed => something else changed => invalidate users list
                this.usersDirty = true;
            }
            this.loadReportlines();
        }
    }

    resultHeaders: Header[] = [
        {text: "Anlegg", value: "terminalLocation.description", align: left, sortable: false},
        {text: "Inn", value: "timeIn", align: left},
        {text: "Ut", value: "timeOut", align: left},
        {text: "Fornavn", value: "firstName", align: left},
        {text: "Etternavn", value: "lastName", align: left},
        {text: "Født", value: "birthDate", align: left, sortable: false},
        {text: "Firma", value: "companyName", align: left},
        {text: "Kortnr", value: "cardNum", align: left},
        {text: "Telefon", value: "phoneNumber", align: left, sortable: false}
    ];

    result: RegReportResult = new RegReportResult([], false);
    get resultItems() : SiteInOutReportLine[] {
        return this.result.lines;
    }

    tablefilter<K extends keyof SiteInOutReportLine>(val: SiteInOutReportLine[K], search: string): boolean {
        let strval = "";
        if(val != null) {
            if(val instanceof DateTime) {
                strval = val.toLocalDateTime();
            }
            if(val instanceof PhoneNumber) {
                strval = val.toString();
            }
            if(typeof val == "number") {
                strval = (val as number).toString();
            }
            if(typeof val == "string") {
                strval = (val as string).toLocaleLowerCase();
            }
        }
        return strval.includes(search);
    }

    loadDebouncer = new Debouncer(1000);
    async loadReportlines() {
        this.loading = true;
        let run = false;
        try {
            run = await this.loadDebouncer.debounce()
            if(run) {
                this.result = await this.api.regReport(
                    this.company.orgNum,
                    this.routeParams.from,
                    this.routeParams.to,
                    this.routeParams.filterOrgnums,
                    this.routeParams.filterLocationIds,
                    this.routeParams.filterUserGuids,
                    this.routeParams.page,
                    this.routeParams.ordering,
                );
            }
        } finally {
            if(run) {
                this.loading = false;
            }
        }
    }

    formatDateTime(dt: DateTime): string | null {
        return dt != null ? dt.toLocalDateTime(): null;
    }
    formatDate(dt: DateTime): string | null {
        return dt != null ? dt.toLocalDate() : null;
    }
    numberOrNull(n: number): number | null {
        return numOrNull(n);
    }

    get from() {
        return this.routeParams.from;
    }
    set from(v: DateTime | null) {
        this.updateRouteParams(this.routeParams.withFrom(v));
    }
    get to() {
        return this.routeParams.to;
    }
    set to(v: DateTime | null) {
        this.updateRouteParams(this.routeParams.withTo(v));
    }

    prevDay() {
        if(this.routeParams.from != null) {
            this.updateRouteParams(this.routeParams.withFrom(this.routeParams.from.prevDay()));
        }
    }
    nextDay() {
        if(this.routeParams.from != null) {
            this.updateRouteParams(this.routeParams.withFrom(this.routeParams.from.nextDay()));
        }
    }

    updateRouteParams(v: RegistrationsPageRouteParams) {
        this.$emit("update-route-params", v);
    }

    isOrgNumFiltered(n: number): boolean {
        return this.filterOrgNums.indexOf(n) > -1;
    }
    toggleFilterOrgNum(n: number) {
        if(this.isOrgNumFiltered(n)) {
            this.updateRouteParams(this.routeParams.minusFilterOrgNum(n))
        } else if(this.filterOrgNums.length >= this.maxCheckedFilterCount) {
            // We've hit max limit, notify user
            this.emitSnack(`Du kan ikke velge mer enn ${this.maxCheckedFilterCount} firma å filtrere på.`, WarningColor);
        } else {
            this.updateRouteParams(this.routeParams.plusFilterOrgNum(n));
        }
    }
    clearFilterOrgNums() {
        const rp = this.routeParams.clone();
        if(rp.filterOrgnums.length > 0) {
            rp.filterOrgnums = [];
            this.updateRouteParams(rp);
        }
    }

    get filterOrgNums() {
        return this.routeParams.filterOrgnums;
    }
    get filterLocationIds() {
        return this.routeParams.filterLocationIds;
    }
    isLocationIdFiltered(id: number): boolean {
        return this.filterLocationIds.indexOf(id) > -1;
    }
    toggleFilterLocationId(id: number) {
        if(this.isLocationIdFiltered(id)) {
            this.updateRouteParams(this.routeParams.minusFilterLocationId(id));
        } else if(this.filterLocationIds.length >= this.maxCheckedFilterCount) {
            this.emitSnack(`Du kan ikke velge mer enn ${this.maxCheckedFilterCount} anlegg å filtrere på.`, WarningColor);
        } else {
            this.updateRouteParams(this.routeParams.plusFilterLocationId(id))
        }
    }
    clearFilterLocationIds() {
        const rp = this.routeParams.clone();
        if(rp.filterLocationIds.length > 0) {
            rp.filterLocationIds = [];
            this.updateRouteParams(rp);
        }
    }

    // List of companies that could appear in result. So that we can offer to filter on them
    companies: Company[] = [];
    loadingCompanies = false;
    companiesDirty = true;
    async loadCompanies() {
        this.loadingCompanies = true;
        try {
            this.companies = await this.api.regReportCompanies(
                this.company.orgNum,
                this.routeParams.from,
                this.routeParams.to,
                this.routeParams.filterLocationIds,
                this.routeParams.filterUserGuids,
            );
        } finally {
            this.loadingCompanies = false;
            this.companiesDirty = false;
        }
    }
    // List of locations the user can filter on
    locations: TerminalLocationWithStats[] = [];
    async loadLocations() {
        // Want a little delay here since this is not the most urgent to load
        await delay(2000);
        this.locations = await this.api.fetchLocations(this.company.orgNum);
    }

    @Watch("company", {immediate: true})
    companyChanged(c: Company | null) {
        if(c != null) {
            this.loadLocations();
        }
    }

    get excelReportUrl() {
        const route = Routes.regReportXlsx(this.company.orgNum);
        return route + queryParams(this.routeParams.routeQuery());
    }
    cardColor(srl: SiteInOutReportLine): string {
        let clr = srl.phoneNumber == null ? this.defaultCardColor : this.unimportantColor;
        if(IdCard.isExpired(srl.expirationDate, srl.timeIn)) {
            clr = ErrorColor;
        } else if(IdCard.isSoonExpired(srl.expirationDate, srl.timeIn)) {
            clr = WarningColor;
        }
        return clr;
    }
    cardTooltipTxt(srl: SiteInOutReportLine): string {
        let txt = srl.phoneNumber != null ? 'Kort tilknyttet innlogget bruker' : 'Innregistrert med kort på kortleser';
        if(IdCard.isExpired(srl.expirationDate, srl.timeIn)) {
            txt = `Kort er utgått på dato (${srl.expirationDate.toLocalDate()})`;
        } else if(IdCard.isSoonExpired(srl.expirationDate, srl.timeIn)) {
            txt = `Kortets utløpsdato nærmer seg (${srl.expirationDate.toLocalDate()})`;
        }
        return txt;
    }

    prevPage() {
        if(this.routeParams.page > 1) {
            this.updateRouteParams(this.routeParams.withPage(this.routeParams.page - 1));
        }
    }
    nextPage() {
        if(this.result.hasMore) {
            this.updateRouteParams(this.routeParams.withPage(this.routeParams.page + 1));
        }
    }
    get ordering() {
        return this.routeParams.ordering;
    }
    set ordering(v: number) {
        this.updateRouteParams(this.routeParams.withOrdering(v));
    }

    pShowCompanyFilterDlg = false;
    get showCompanyFilterDlg() {
        return this.pShowCompanyFilterDlg;
    }
    set showCompanyFilterDlg(v: boolean) {
        this.pShowCompanyFilterDlg = v;
        if(v && this.companiesDirty) {
            this.loadCompanies();
        }
    }
    showLocationFilterDlg = false;

    usersDirty = true;
    pShowUserFilterDlg = false;
    get showUserFilterDlg() {
        return this.pShowUserFilterDlg;
    }
    set showUserFilterDlg(v: boolean) {
        this.pShowUserFilterDlg = v;
        if(v && this.usersDirty) {
            this.loadUsers();
        }
    }

    users: GuiUserlisting[] = [];
    usrSearch: string = "";
    loadingUsers = false;
    async loadUsers() {
        this.loadingUsers = true;
        try {
            this.users = await this.api.regReportUsers(
                this.company.orgNum,
                this.from,
                this.to,
                this.routeParams.filterOrgnums,
                this.routeParams.filterLocationIds,
                this.usrSearch.length > 0 ? this.usrSearch : null,
            );
        } finally {
            this.loadingUsers = false;
            this.usersDirty = false;
        }
    }

    get filterUserGuids() {
        return this.routeParams.filterUserGuids;
    }
    set filterUserGuids(guids: string[]) {
        const rp = this.routeParams.clone();
        rp.filterUserGuids = guids;
        this.updateRouteParams(rp)
    }
    isUserGuidFiltered(guid: string): boolean {
        return this.filterUserGuids.indexOf(guid) > -1;
    }
    toggleFilterUserGuid(guid: string) {
        if(this.isUserGuidFiltered(guid)) {
            this.filterUserGuids = this.filterUserGuids.filter(r => r != guid);
        } else if(this.filterUserGuids.length >= this.maxCheckedFilterCount) {
            this.emitSnack(`Du kan ikke velge mer enn ${this.maxCheckedFilterCount} brukere for filtrering.`, WarningColor)
        } else {
            this.filterUserGuids = [...this.filterUserGuids, guid];
        }

    }
    clearFilterUserGuids() {
        const rp = this.routeParams.clone();
        if(rp.filterUserGuids.length > 0) {
            rp.filterUserGuids = [];
            this.updateRouteParams(rp);
        }
    }
    filteroutPhone(pns: PhoneNumber[], pn: PhoneNumber | null) {
      if(pn == null) {
        return pns;
      } else {
        return pns.filter(r => !r.equals(pn));
      }
    }

}
